import { GridPattern } from '@/components/grid-pattern';
import { cn } from '@/lib/utils';

export function HeroPattern({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'absolute inset-0 -z-10 mx-0 max-w-none overflow-hidden',
        className,
      )}
    >
      <div className="absolute top-0 left-1/2 ml-[-38rem] h-[30rem] w-[81.25rem] dark:[mask-image:linear-gradient(white,transparent)]">
        <div className="absolute inset-0 bg-linear-to-r opacity-40 [mask-image:radial-gradient(farthest-side_at_top,white,transparent)] from-[#1CEFA5]/40 to-[#3C4568]/40 opacity-100">
          <GridPattern
            width={72}
            height={72}
            x={-12}
            y={4}
            squares={[
              [4, 3],
              [2, 1],
              [7, 3],
              [10, 6],
            ]}
            className="absolute inset-x-0 inset-y-[-50%] h-[200%] w-full skew-y-[-14deg] mix-blend-overlay fill-[#171a25] stroke-black/20"
          />
        </div>
      </div>
    </div>
  );
}

export function HeroPatternNew({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'absolute inset-0 -z-10 mx-0 max-w-none overflow-hidden',
        className,
      )}
    >
      <div className="absolute top-0 left-1/2 ml-[-38rem] h-[32rem] w-[81.25rem] dark:[mask-image:linear-gradient(white,transparent)]">
        <div className="absolute inset-0 bg-linear-to-r opacity-40 [mask-image:radial-gradient(farthest-side_at_center,white,transparent)] from-[#1CEFA5]/40 to-[#3C4568]/40 opacity-100">
          <GridPattern
            width={72}
            height={72}
            x={-12}
            y={4}
            squares={[
              [4, 3],
              [2, 1],
              [7, 3],
              [10, 6],
              [14, 8],
              [7, 8],
              [3, 6],
            ]}
            className="absolute inset-x-0 inset-y-[-50%] h-[200%] w-full skew-y-[-14deg] mix-blend-overlay fill-[#171a25] stroke-black/20"
          />
        </div>
      </div>
    </div>
  );
}
